export const paaasSesa = [
  {
    item_nombre: "Programa Anual de Adquisiciones Arrendamientos y Servicios",
    item_url: "../contenido/transparencia/paaas/PAAAS 2023.pdf",
    item_descripcion: "Ejercicio Fiscal 2023"
  },
  {
    item_nombre: "Programa Anual de Adquisiciones Arrendamientos y Servicios",
    item_url: "../contenido/transparencia/paaas/Programa Anual de Adquisiciones 2022 SESA.pdf",
    item_descripcion: "Ejercicio Fiscal 2022"
  },
  {
    item_nombre: "Programa Anual de Adquisiciones Arrendamientos y Servicios",
    item_url: "../contenido/transparencia/paaas/PAAAS_2021.pdf",
    item_descripcion: "Ejercicio Fiscal 2021"
  },
  {
    item_nombre: "Programa Anual de Adquisiciones Arrendamientos y Servicios",
    item_url: "../contenido/transparencia/paaas/PAAAS_2020.pdf",
    item_descripcion: "Ejercicio Fiscal 2020"
  }
];